import React from "react";
import styled, { css } from "styled-components";
import { ColorV2 } from "config/colors";

export type ListRowVariant = "light" | "dark";

export interface ListRowProps {
  variant?: ListRowVariant;
  selected?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
  role?: string;
  tabIndex?: number;
  children?: React.ReactNode;
}

/** Reusable list row container with selectable styling. */
export const ListRow = ({
  id,
  role,
  tabIndex,
  className,
  style,
  onClick,
  onMouseLeave,
  onMouseEnter,
  variant = "light",
  selected = false,
  children,
}: ListRowProps): JSX.Element => {
  return (
    <Row
      id={id}
      role={role}
      tabIndex={tabIndex}
      className={className}
      style={style}
      onClick={onClick}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      $variant={variant}
      $selected={selected}
      $clickable={Boolean(onClick)}
    >
      {children}
    </Row>
  );
};

const Row = styled.div<{
  $variant: ListRowVariant;
  $selected: boolean;
  $clickable: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 16px;
  border: 1px solid
    ${(props) =>
      props.$selected && props.$variant === "light"
        ? ColorV2.Blue5
        : "transparent"};
  background: ${(props) =>
    props.$variant === "dark" ? ColorV2.Blue7 : ColorV2.White};
  ${(props) =>
    props.$clickable &&
    css`
      cursor: pointer;
    `}
`;
